import React, { useState, useEffect } from 'react';
import {
    Card, CardHeader, Divider, CardContent, TextField, TableContainer, Button,
    Table, TableHead, TableRow, TableCell, TableBody, IconButton, Tooltip,
    Grid, Backdrop, CircularProgress, Snackbar, TablePagination,
    Checkbox, Paper, MenuItem, Menu, TableSortLabel, Popover, Box, InputAdornment
} from '@material-ui/core';
import axios from 'src/utils/axios';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { Autocomplete, Stack } from '@mui/material';
import Alert from 'src/components/Alert';
import Page from 'src/components/Page';
import moment from 'moment';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { confirmAlert } from 'react-confirm-alert';
import { makeStyles } from '@material-ui/core/styles';
import ExcelFileCreator from 'src/components/ExcelFileCreator';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import ClearIcon from '@mui/icons-material/Clear';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
    },
    backdrop: {
        zIndex: 9999,
        color: '#fff',
    },
}));

function LocationManagement() {
    const classes = useStyles();

    // Table'a gelecek olan Ana data
    const [mainData, setMainData] = useState([]);

    // Ekle Butonunda bulunan AutoComplete alanları
    const [cityInput, setCityInput] = useState([]);
    const [districtInput, setDistrictInput] = useState([]);
    const [assignmentCityInput, setAssignmentCityInput] = useState([]);
    const [assignmentDistrictInput, setAssignmentDistrictInput] = useState([]);

    // Ekle Butonunda bulunan AutoComplete alanları için seçilen değerler
    const [selectedCityInput, setSelectedCityInput] = useState(null);
    const [selectedDistrictInput, setSelectedDistrictInput] = useState(null);
    const [selectedAssignmentCityInput, setSelectedAssignmentCityInput] = useState(null);
    const [selectedAssignmentDistrictInput, setSelectedAssignmentDistrictInput] = useState(null);

    // Filtreleme işlemleri
    const [statusFilter, setStatusFilter] = useState('all'); // Filtre durumu
    const [anchorEl, setAnchorEl] = useState(null); // Menü açma/kapatma kontrolü

    // Tümünü Seç işlemleri
    const [selectAll, setSelectAll] = useState(false);

    // Sıralama İşlemleri
    const [orderDirection, setOrderDirection] = useState('asc');
    const [orderBy, setOrderBy] = useState('');

    // Filtreleme işlemleri için kullanılacak olan state'ler
    const [activeFilterColumn, setActiveFilterColumn] = useState(null);
    const [filterAnchorEl, setFilterAnchorEl] = useState(null);

    const [depoIlceFilter, setDepoIlceFilter] = useState('');
    const [depoMahalleFilter, setDepoMahalleFilter] = useState('');
    const [atamaIlceFilter, setAtamaIlceFilter] = useState('');
    const [atamaMahalleFilter, setAtamaMahalleFilter] = useState('');

    // Pagination işlemleri
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    // Loading ve Uyarılar
    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = useState('default');
    const [responseMessage, setresponseMessage] = useState('');

    useEffect(() => {
        getCities();
    }, []);

    useEffect(() => {
        if (mainData.length > 0) {
            // Filtrelenmiş veriyi oluştur
            const updatedFilteredData = mainData.filter(row => {
                if (statusFilter === 'all') return true;
                if (statusFilter === 'active') return row.AKTIF === 1;
                if (statusFilter === 'inactive') return row.AKTIF === 0;
                return true;
            });

            // Eğer tüm veriler aktifse `selectAll` aktif olacak
            const allActive = updatedFilteredData.length > 0 && updatedFilteredData.every(row => row.AKTIF === 1);
            setSelectAll(allActive);
        } else {
            setSelectAll(false);
        }
    }, [mainData, statusFilter]);

    const getComparator = (order, orderBy) => {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    };

    const descendingComparator = (a, b, orderBy) => {
        if (orderBy === 'KAYIT_TARIHI') {
            const aDate = moment(a[orderBy], 'YYYY-MM-DDTHH:mm:ss'); // veya mevcut formatına göre ayarla
            const bDate = moment(b[orderBy], 'YYYY-MM-DDTHH:mm:ss');

            if (!aDate.isValid() || !bDate.isValid()) return 0;

            return bDate - aDate;
        }

        return b[orderBy]?.toString().localeCompare(a[orderBy]?.toString(), 'tr', { sensitivity: 'base' });
    };

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && orderDirection === 'asc';
        setOrderDirection(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleFilterIconClick = (event, columnName) => {
        if (activeFilterColumn === columnName && filterAnchorEl) {
            setActiveFilterColumn(null);
            setFilterAnchorEl(null);
        } else {
            setActiveFilterColumn(columnName);
            setFilterAnchorEl(event.currentTarget);
        }
    };

    const handlePopoverClose = () => {
        setActiveFilterColumn(null);
        setFilterAnchorEl(null);
    };

    const getTownDistrictNeighborhoodData = (cityParam, districtParam, assignmentCityParam, assignmentDistrictParam) => {
        axios.get(`/GetApolloCityDistrictNeighborhoodInformation/${cityParam}/${districtParam}/${assignmentCityParam}/${assignmentDistrictParam}`)
            .then((response) => {
                if (response.data && response.data.length > 0) {
                    setMainData(response.data);
                } else {
                    setMainData([]);
                }
            })
            .catch((error) => {

            });
    }

    const getCities = () => {
        axios.get('/GetApolloCityCatalog')
            .then(response => {
                setCityInput(response.data);
                setAssignmentCityInput(response.data);
            })
            .catch(error => {
                setCityInput([]);
                setAssignmentCityInput([]);
            });
    }

    const handleCityChangeForDepo = (event, newValue) => {
        setSelectedCityInput(newValue);

        setMainData([]); // Eğer şehir seçildiyse, tabloyu sıfırla

        // Eğer bir şehir seçildiyse, ilçeleri yükle
        if (newValue) {
            const cityName = newValue.IL_AD;

            axios.get(`/GetApolloDistrictsFromCityCatalog/${cityName}`)
                .then(response => {
                    setDistrictInput(response.data);
                })
                .catch(error => {
                    setDistrictInput([]);
                });

        } else {
            setDistrictInput([]); // Eğer şehir seçilmediyse ilçeleri sıfırla
            setSelectedDistrictInput([]); // Eğer şehir seçilmediyse ilçeleri sıfırla
        }
    };

    const handleCityChangeForAtanan = (event, newValue) => {
        setSelectedAssignmentCityInput(newValue);

        setMainData([]); // Eğer şehir seçildiyse, tabloyu sıfırla

        // Eğer bir şehir seçildiyse, ilçeleri yükle
        if (newValue) {
            const cityName = newValue.IL_AD;

            axios.get(`/GetApolloDistrictsFromCityCatalog/${cityName}`)
                .then(response => {
                    setAssignmentDistrictInput(response.data);
                })
                .catch(error => {
                    setAssignmentDistrictInput([]);
                });
        } else {
            setAssignmentDistrictInput([]); // Eğer şehir seçilmediyse ilçeleri sıfırla
            setSelectedAssignmentDistrictInput([]); // Eğer şehir seçilmediyse ilçeleri sıfırla
        }
    };

    const handleCheckboxChange = (event, rowId) => {
        const updatedStatus = event.target.checked ? 1 : 0;

        const data = {
            id: rowId,
            aktif: updatedStatus,
        };

        setLoading(true);
        axios.post('/SetUpdateCityDistrictNeighborhood', data)
            .then(response => {
                if (response.data.ErrorCode === "0") {

                    // mainData'yı UI tarafında güncelle
                    const updatedData = mainData.map((row) =>
                        row.ID === rowId ? { ...row, AKTIF: updatedStatus } : row
                    );
                    setMainData(updatedData);

                    setLoading(false);

                    setUyari(true);
                    setUyariTip('success');
                    setresponseMessage('Güncelleme işlemi başarılı.');
                } else {
                    setLoading(false);
                    setUyari(true);
                    setUyariTip('error');
                    setresponseMessage('Güncelleme işlemi başarısız.');
                }
            })
            .catch(error => {
                setLoading(false);
            });
    };

    const handleSearchClick = () => {
        if (selectedCityInput === null || selectedDistrictInput === null || selectedAssignmentCityInput === null || selectedAssignmentDistrictInput === null) {
            setUyari(true);
            setUyariTip('error');
            setresponseMessage('Lütfen tüm alanları doldurun.');
            return;
        }

        const data = {
            city: selectedCityInput?.IL_AD || "",
            district: selectedDistrictInput?.ILCE_AD || "",
            assignmentCity: selectedAssignmentCityInput?.IL_AD || "",
            assignmentDistrict: selectedAssignmentDistrictInput?.ILCE_AD || ""
        };


        setLoading(true);
        axios.get(`/GetApolloCityDistrictNeighborhoodInformation/${data.city}/${data.district}/${data.assignmentCity}/${data.assignmentDistrict}`)
            .then((response) => {
                if (response.data && response.data.length > 0) {
                    setMainData(response.data);
                } else {
                    setMainData([]);
                }

                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    }

    const handleAddClick = () => {
        if (selectedCityInput === null || selectedDistrictInput === null || selectedAssignmentCityInput === null || selectedAssignmentDistrictInput === null) {
            setUyari(true);
            setUyariTip('error');
            setresponseMessage('Lütfen tüm alanları doldurun.');
            return;
        }

        const data = {
            city: selectedCityInput.IL_AD,
            district: selectedDistrictInput.ILCE_AD,
            assignmentCity: selectedAssignmentCityInput.IL_AD,
            assignmentDistrict: selectedAssignmentDistrictInput.ILCE_AD
        };

        setLoading(true);
        axios.post('/SetAddNewCityDistrictNeighborhood', data)
            .then((response) => {
                if (response.data.ErrorCode === "0") {
                    // Başarılı işlem sonrası veriyi güncelle
                    getTownDistrictNeighborhoodData(data.city, data.district, data.assignmentCity, data.assignmentDistrict);

                    // Formu sıfırla
                    setSelectedCityInput([]);
                    setSelectedDistrictInput([]);
                    setSelectedAssignmentCityInput([]);
                    setSelectedAssignmentDistrictInput([]);

                    // Loading'i kapat
                    setLoading(false);

                    // Başarı mesajı göster
                    setUyari(true);
                    setUyariTip('success');
                    setresponseMessage('Ekleme işlemi başarılı.');
                } else {
                    setLoading(false);

                    // Hata mesajı göster
                    setUyari(true);
                    setUyariTip('error');
                    setresponseMessage('Ekleme işlemi başarısız.');
                }
            })
            .catch((error) => {
                setLoading(false);
            });
    };

    const filteredData = mainData.filter(row => {
        const statusMatch =
            statusFilter === 'all' ||
            (statusFilter === 'active' && row.AKTIF === 1) ||
            (statusFilter === 'inactive' && row.AKTIF === 0);

        const normalizeText = (text) => {
            return text
                ?.toString()
                .toLocaleLowerCase('tr-TR')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        };

        return (
            statusMatch &&
            normalizeText(row.DEPO_ILCE).includes(normalizeText(depoIlceFilter)) &&
            normalizeText(row.DEPO_MAHALLE).includes(normalizeText(depoMahalleFilter)) &&
            normalizeText(row.ATAMA_ILCE).includes(normalizeText(atamaIlceFilter)) &&
            normalizeText(row.ATAMA_MAHALLE).includes(normalizeText(atamaMahalleFilter))
        );
    });


    const handleSelectAllChange = (event) => {
        if (filteredData.length === 0) {
            return;
        }

        const isChecked = event.target.checked;

        confirmAlert({
            message: isChecked
                ? 'Tüm kayıtları aktif hale getirmek istiyor musunuz?'
                : 'Tüm kayıtları pasif hale getirmek istiyor musunuz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        setLoading(true);
                        setSelectAll(isChecked);

                        // filteredData üzerinden sadece ekranda görünen verileri güncelle
                        const updatedFilteredData = filteredData.map(row => ({
                            ...row,
                            AKTIF: isChecked ? 1 : 0
                        }));

                        // mainData içindeki verileri de güncellemek için map kullan
                        const updatedMainData = mainData.map(row => {
                            const foundRow = updatedFilteredData.find(fRow => fRow.ID === row.ID);
                            return foundRow ? { ...row, AKTIF: isChecked ? 1 : 0 } : row;
                        });

                        // API'ye güncellenmiş verileri gönder
                        axios.post('/SetUpdateAllCityDistrictNeighborhood', updatedFilteredData)
                            .then(response => {
                                if (response.data.ErrorCode == "0") {
                                    setMainData(updatedMainData); // UI'yi güncelle
                                    setStatusFilter('all'); // Filtreyi sıfırla

                                    setUyari(true);
                                    setUyariTip('success');
                                    setresponseMessage(isChecked ? 'Tüm kayıtlar aktif edildi.' : 'Tüm kayıtlar pasif hale getirildi.');
                                } else {
                                    setUyari(true);
                                    setUyariTip('error');
                                    setresponseMessage('Güncelleme işlemi başarısız.');
                                }
                                setLoading(false);
                            })
                            .catch(error => {
                                setUyari(true);
                                setUyariTip('error');
                                setresponseMessage('Güncelleme sırasında bir hata oluştu.');
                                setLoading(false);
                            })
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => {
                        setSelectAll(!isChecked);
                    }
                }
            ]
        });
    };

    const handleExportClick = () => {
        if (filteredData.length === 0) {
            setUyari(true);
            setUyariTip('error');
            setresponseMessage('Export edilecek veri bulunmamaktadır.');
            return;
        }

        const dataToExport = filteredData.map(row => ({
            ID: row.ID,
            DEPO_ILCE: row.DEPO_ILCE,
            DEPO_MAHALLE: row.DEPO_MAHALLE,
            ATAMA_ILCE: row.ATAMA_ILCE,
            ATAMA_MAHALLE: row.ATAMA_MAHALLE,
            KAYDEDEN_KISI: row.ADSOYAD || '-',
            KAYIT_TARIHI: row.KAYIT_TARIHI
                ? moment(row.KAYIT_TARIHI).format('DD/MM/YYYY HH:mm:ss')
                : '-',
            GUNCELLEYEN_KISI: row.GUNCELLEYEN || '-',
            GUNCELLEME_TARIHI: row.GUNCELLEME_TARIHI
                ? moment(row.GUNCELLEME_TARIHI).format('DD/MM/YYYY HH:mm:ss')
                : '-',
            AKTIFLIK: row.AKTIF === 1 ? 'Aktif' : 'Pasif',
        }));

        ExcelFileCreator(dataToExport, 'Bayi_Dış_Teslim_İl_İlçe');

    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    return (
        <Page className={classes.root}>
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage} />
            </Snackbar>
            <Card>
                <CardHeader title="Bayi Dış Teslim İl İlçe" />
                <Divider />
                <CardContent>
                    <Grid container spacing={2}>
                        {/* Depo İl */}
                        <Grid item xs={12} md={3} lg={3}>
                            <Autocomplete
                                value={selectedCityInput}
                                onChange={(event, newValue) => { handleCityChangeForDepo(event, newValue); }}
                                options={cityInput}
                                getOptionLabel={(option) => option.IL_AD || ''}
                                renderInput={(params) => <TextField {...params} label="Depo İl" variant="outlined" fullWidth />}
                                sx={{
                                    '& .MuiAutocomplete-endAdornment': {
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                    }
                                }}
                            />
                        </Grid>
                        {/* Depo İlçe */}
                        <Grid item xs={12} md={3} lg={3}>
                            <Autocomplete
                                value={selectedDistrictInput}
                                onChange={(event, newValue) => { setSelectedDistrictInput(newValue); setMainData([]); }}
                                options={districtInput}
                                getOptionLabel={(option) => option.ILCE_AD || ''}
                                renderInput={(params) => <TextField {...params} label="Depo İlçe" variant="outlined" fullWidth />}
                                sx={{
                                    '& .MuiAutocomplete-endAdornment': {
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                    }
                                }}
                            />
                        </Grid>
                        {/* Atanan İl */}
                        <Grid item xs={12} md={3} lg={3}>
                            <Autocomplete
                                value={selectedAssignmentCityInput}
                                onChange={(event, newValue) => { handleCityChangeForAtanan(event, newValue); }}
                                options={cityInput}
                                getOptionLabel={(option) => option.IL_AD || ''}
                                renderInput={(params) => <TextField {...params} label="Atanan İl" variant="outlined" fullWidth />}
                                sx={{
                                    '& .MuiAutocomplete-endAdornment': {
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                    }
                                }}
                            />
                        </Grid>
                        {/* Atanan İlçe */}
                        <Grid item xs={12} md={3} lg={3}>
                            <Autocomplete
                                value={selectedAssignmentDistrictInput}
                                onChange={(event, newValue) => { setSelectedAssignmentDistrictInput(newValue); setMainData([]); }}
                                options={assignmentDistrictInput}
                                getOptionLabel={(option) => option.ILCE_AD || ''}
                                renderInput={(params) => <TextField {...params} label="Atanan İlçe" variant="outlined" fullWidth />}
                                sx={{
                                    '& .MuiAutocomplete-endAdornment': {
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={false} md={6} />
                        <Grid item xs={12} md={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                fullWidth
                                endIcon={<SearchIcon />}
                                onClick={() => { handleSearchClick(); }}>
                                Arama Yap
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                fullWidth
                                endIcon={<AddIcon />}
                                onClick={() => { handleAddClick(); }}>
                                Ekle
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                fullWidth
                                endIcon={<SaveAltIcon />}
                                onClick={() => { handleExportClick(); }}
                            >
                                EXCEL İNDİR
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
                <Divider />
                <CardContent>
                    <TableContainer component={Paper} style={{ marginTop: 10, maxHeight: 600 }}>
                        <Table stickyHeader aria-label="sticky table" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell align='center'>No</TableCell>
                                    <TableCell align="center">
                                        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                            <TableSortLabel
                                                active={orderBy === 'DEPO_ILCE'}
                                                direction={orderBy === 'DEPO_ILCE' ? orderDirection : 'asc'}
                                                onClick={() => handleRequestSort('DEPO_ILCE')}
                                            >
                                                Depo İlçe
                                            </TableSortLabel>
                                            <IconButton
                                                size="small"
                                                onClick={(e) => handleFilterIconClick(e, 'DEPO_ILCE')}
                                            >
                                                <FilterAltIcon fontSize="small" />
                                            </IconButton>
                                        </Stack>
                                    </TableCell>

                                    <TableCell align="center">
                                        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                            <TableSortLabel
                                                active={orderBy === 'DEPO_MAHALLE'}
                                                direction={orderBy === 'DEPO_MAHALLE' ? orderDirection : 'asc'}
                                                onClick={() => handleRequestSort('DEPO_MAHALLE')}
                                            >
                                                Depo Mahalle
                                            </TableSortLabel>
                                            <IconButton
                                                size="small"
                                                onClick={(e) => handleFilterIconClick(e, 'DEPO_MAHALLE')}
                                            >
                                                <FilterAltIcon fontSize="small" />
                                            </IconButton>
                                        </Stack>
                                    </TableCell>

                                    <TableCell align="center">
                                        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                            <TableSortLabel
                                                active={orderBy === 'ATAMA_ILCE'}
                                                direction={orderBy === 'ATAMA_ILCE' ? orderDirection : 'asc'}
                                                onClick={() => handleRequestSort('ATAMA_ILCE')}
                                            >
                                                Atama İlçe
                                            </TableSortLabel>
                                            <IconButton
                                                size="small"
                                                onClick={(e) => handleFilterIconClick(e, 'ATAMA_ILCE')}
                                            >
                                                <FilterAltIcon fontSize="small" />
                                            </IconButton>
                                        </Stack>
                                    </TableCell>

                                    <TableCell align="center">
                                        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                            <TableSortLabel
                                                active={orderBy === 'ATAMA_MAHALLE'}
                                                direction={orderBy === 'ATAMA_MAHALLE' ? orderDirection : 'asc'}
                                                onClick={() => handleRequestSort('ATAMA_MAHALLE')}
                                            >
                                                Atama Mahalle
                                            </TableSortLabel>
                                            <IconButton
                                                size="small"
                                                onClick={(e) => handleFilterIconClick(e, 'ATAMA_MAHALLE')}
                                            >
                                                <FilterAltIcon fontSize="small" />
                                            </IconButton>
                                        </Stack>
                                    </TableCell>
                                    <TableCell align='center' sortDirection={orderBy === 'ADSOYAD' ? orderDirection : false}>
                                        <TableSortLabel
                                            active={orderBy === 'ADSOYAD'}
                                            direction={orderBy === 'ADSOYAD' ? orderDirection : 'asc'}
                                            onClick={() => handleRequestSort('ADSOYAD')}
                                        >
                                            Kaydeden Kişi
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell align='center' sortDirection={orderBy === 'KAYIT_TARIHI' ? orderDirection : false}>
                                        <TableSortLabel
                                            active={orderBy === 'KAYIT_TARIHI'}
                                            direction={orderBy === 'KAYIT_TARIHI' ? orderDirection : 'asc'}
                                            onClick={() => handleRequestSort('KAYIT_TARIHI')}
                                        >
                                            Kayıt Tarihi
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell align='center' sortDirection={orderBy === 'GUNCELLEYEN' ? orderDirection : false}>
                                        <TableSortLabel
                                            active={orderBy === 'GUNCELLEYEN'}
                                            direction={orderBy === 'GUNCELLEYEN' ? orderDirection : 'asc'}
                                            onClick={() => handleRequestSort('GUNCELLEYEN')}
                                        >
                                            Güncelleyen Kişi
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell align='center' sortDirection={orderBy === 'GUNCELLEME_TARIHI' ? orderDirection : false}>
                                        <TableSortLabel
                                            active={orderBy === 'GUNCELLEME_TARIHI'}
                                            direction={orderBy === 'GUNCELLEME_TARIHI' ? orderDirection : 'asc'}
                                            onClick={() => handleRequestSort('GUNCELLEME_TARIHI')}
                                        >
                                            Güncelleme Tarihi
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell>
                                        <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
                                            <Tooltip title="Tümünü Seç" placement="top">
                                                <Checkbox
                                                    checked={selectAll}
                                                    onChange={handleSelectAllChange}
                                                    color="primary"
                                                />
                                            </Tooltip>
                                            {'Aktif/Pasif'}
                                            <Tooltip title="Filtrele" placement="top">
                                                <IconButton
                                                    onClick={(event) => setAnchorEl(event.currentTarget)}
                                                    size="small"
                                                    aria-label="filter"
                                                    style={{ marginLeft: 4 }}
                                                >
                                                    <FilterAltIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Stack>
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={() => setAnchorEl(null)}
                                        >
                                            <MenuItem
                                                onClick={() => { setStatusFilter('all'); setAnchorEl(null); }}
                                                style={{ backgroundColor: statusFilter === 'all' ? '#f0f0f0' : 'transparent' }}
                                            >
                                                Tümü
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => { setStatusFilter('active'); setAnchorEl(null); }}
                                                style={{ backgroundColor: statusFilter === 'active' ? '#f0f0f0' : 'transparent' }}
                                            >
                                                Aktif
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => { setStatusFilter('inactive'); setAnchorEl(null); }}
                                                style={{ backgroundColor: statusFilter === 'inactive' ? '#f0f0f0' : 'transparent' }}
                                            >
                                                Pasif
                                            </MenuItem>
                                        </Menu>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData
                                    .slice()
                                    .sort(getComparator(orderDirection, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row) => (
                                        <TableRow key={row.ID}>
                                            <TableCell align='center'>{row.ID}</TableCell>
                                            <TableCell align='center'>{row.DEPO_ILCE}</TableCell>
                                            <TableCell align='center'>{row.DEPO_MAHALLE}</TableCell>
                                            <TableCell align='center'>{row.ATAMA_ILCE}</TableCell>
                                            <TableCell align='center'>{row.ATAMA_MAHALLE}</TableCell>
                                            <TableCell align='center'>{row.ADSOYAD ? row.ADSOYAD : '-'}</TableCell>
                                            <TableCell align='center'>{row.KAYIT_TARIHI ? moment(row.KAYIT_TARIHI).format('DD/MM/YYYY HH:mm:ss') : '-'}</TableCell>
                                            <TableCell align='center'>{row.GUNCELLEYEN ? row.GUNCELLEYEN : '-'}</TableCell>
                                            <TableCell align='center'>{row.GUNCELLEME_TARIHI ? moment(row.GUNCELLEME_TARIHI).format('DD/MM/YYYY HH:mm:ss') : '-'}</TableCell>
                                            <TableCell align='center'>
                                                <Checkbox
                                                    checked={row.AKTIF === 1}
                                                    onChange={(event) => handleCheckboxChange(event, row.ID)}
                                                    color="primary"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100, 200]}
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </CardContent>
            </Card>
            <Popover
                open={Boolean(filterAnchorEl)}
                anchorEl={filterAnchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Box sx={{ p: 2 }}>
                    {activeFilterColumn === 'DEPO_ILCE' && (
                        <TextField
                            variant="standard"
                            label="Depo İlçe filtrele"
                            placeholder="Depo İlçe filtrele"
                            value={depoIlceFilter}
                            onChange={(e) => setDepoIlceFilter(e.target.value)}
                            autoFocus
                            InputProps={{
                                spellCheck: false,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            size="small"
                                            onClick={() => setDepoIlceFilter('')}
                                            edge="end"
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    )}
                    {activeFilterColumn === 'DEPO_MAHALLE' && (
                        <TextField
                            variant="standard"
                            label="Depo Mahalle filtrele"
                            placeholder="Depo Mahalle filtrele"
                            value={depoMahalleFilter}
                            onChange={(e) => setDepoMahalleFilter(e.target.value)}
                            autoFocus
                            InputProps={{
                                spellCheck: false,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            size="small"
                                            onClick={() => setDepoMahalleFilter('')}
                                            edge="end"
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    )}
                    {activeFilterColumn === 'ATAMA_ILCE' && (
                        <TextField
                            variant="standard"
                            label="Atama İlçe filtrele"
                            placeholder="Atama İlçe filtrele"
                            fullWidth
                            value={atamaIlceFilter}
                            onChange={(e) => setAtamaIlceFilter(e.target.value)}
                            autoFocus
                            InputProps={{
                                spellCheck: false,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            size="small"
                                            onClick={() => setAtamaIlceFilter('')}
                                            edge="end"
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    )}
                    {activeFilterColumn === 'ATAMA_MAHALLE' && (
                        <TextField
                            variant="standard"
                            label="Atama Mahalle filtrele"
                            placeholder="Atama Mahalle filtrele"
                            value={atamaMahalleFilter}
                            onChange={(e) => setAtamaMahalleFilter(e.target.value)}
                            autoFocus
                            InputProps={{
                                spellCheck: false,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            size="small"
                                            onClick={() => setAtamaMahalleFilter('')}
                                            edge="end"
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    )}
                </Box>
            </Popover>
        </Page>

    )
}

export default LocationManagement;